export default {
  methods: {
    // Weight
    formatLuggageWeightDetails (weightDetails) {
      if (!weightDetails) return ''
      if (weightDetails === '0') return weightDetails

      const weightPerLuggageArray = weightDetails.split('+')
      // Sort same weight values in a object
      const sortedBySameWeight = weightPerLuggageArray.reduce((map, val) => {
        if (!map[val]) {
          map[val] = []
        }
        map[val].push(val)
        return map
      }, {})
      // Sentence construction
      return Object.values(sortedBySameWeight).map((sameValuesArr) => {
        if (sameValuesArr[0].includes('total')) {
          return sameValuesArr[0].split(' ')[0] + ' au total'
        }
        return `${sameValuesArr.length} x ${sameValuesArr[0]}`
      }).join(', ')
    },

    // Quantity
    removePluralAndTranslate (quantitySentence) {
      if (quantitySentence === '0') return quantitySentence

      const quantity = quantitySentence.split(' ')[0]
      const bagWord = quantitySentence.split(' ')[1]
      if (this.$i18n.locale === 'fr') {
        return quantity === '1' && bagWord === 'bags' ? `${quantity} bagage` : `${quantity} bagages`
      }
      return quantity === '1' && bagWord === 'bags' ? `${quantity} bag` : quantitySentence
    }
  }
}
